import { CognitoIdentityProviderClient, VerifyUserAttributeCommand } from "@aws-sdk/client-cognito-identity-provider";
import { fetchAuthSession } from "aws-amplify/auth";
import config from "../amplifyconfiguration.json";

// Verifica el código ingresado por el usuario
const VerifyPhoneCode = async (code) => {
  try {
    const session = await fetchAuthSession();
    const accessToken = session.tokens?.accessToken?.toString();

    const client = new CognitoIdentityProviderClient({
      region: config.aws_project_region,
    });

    const command = new VerifyUserAttributeCommand({
      AccessToken: accessToken,
      AttributeName: "phone_number",
      Code: code,
    });

    await client.send(command);

    return {
      success: true,
      message: "Teléfono verificado correctamente",
    };
  } catch (error) {
    console.error("Error en VerifyPhoneCode:", error);
    return { success: false, error: error.message };
  }
};

export default VerifyPhoneCode;